import {Button, Callout, Checkbox, H3, Intent} from "@blueprintjs/core";
import {observer} from "mobx-react";
import React from "react";

import ProgressPanel from "../../molecules/progress-panel/progress-panel";
import {SubmitGroup} from "../../molecules/submit-group/submit-group";
import {ValidatedInputText} from "../../molecules/validated-input-text/validated-input-text";
import {GuestLayout} from "../../templates/guest-layout/guest-layout";
import {PasswordSettingPageStore} from "./password-setting-page-store";

export const PasswordSettingPage: React.FC<{pageStore: PasswordSettingPageStore}> = observer(
    ({pageStore}) => {
        return (
            <GuestLayout>
                <div style={{width: "400px", margin: "100px auto"}}>
                    <div>
                        {pageStore.requestFailed && (
                            <Callout intent={Intent.DANGER}>
                                パスワードの変更に失敗しました。
                            </Callout>
                        )}

                        {pageStore.connectionFailed && (
                            <Callout intent={Intent.DANGER}>
                                サーバーへの接続に失敗しました。
                            </Callout>
                        )}
                    </div>

                    <H3>パスワード設定</H3>
                    <ProgressPanel inProgress={pageStore.isInProgress}>
                        <SubmitGroup onSubmit={pageStore.tryReset}>
                            <ValidatedInputText
                                label="新しいパスワード"
                                labelForId="new-password"
                                type="password"
                                value={pageStore.newPassword}
                                validationResult={pageStore.newPasswordValidationResult}
                                onChangeValue={pageStore.setNewPassword}
                            />
                            {/* TODO: パスワードの不一致を赤文字にしたい */}
                            {/* 上記対応したが確認後不要であればコメントごと削除対応 */}
                            <ValidatedInputText
                                label="新しいパスワードの確認"
                                labelForId="re-enter-new-password"
                                type="password"
                                helperText={
                                    pageStore.isPasswordMatch
                                        ? ""
                                        : "パスワードが一致していません。"
                                }
                                value={pageStore.confirmPassword}
                                validationResult={pageStore.confirmPasswordValidationResult}
                                onChangeValue={pageStore.setConfirmPassword}
                                helperTextStyle={
                                    pageStore.isPasswordMatch ? {} : {color: "#de0707"}
                                }
                            />
                            <div style={{display: "flex"}} data-testid="privacy-policy">
                                <Checkbox
                                    label=""
                                    onChange={(e) =>
                                        pageStore.setChecked((e.target as HTMLInputElement).checked)
                                    }
                                />
                                <a
                                    href="https://www.beryl-cms.jp/privacy/"
                                    target="_blank"
                                    style={{color: "#6b7e8e"}}
                                >
                                    プライバシーポリシー
                                </a>
                                に同意する
                            </div>
                            <Button
                                type="submit"
                                disabled={!pageStore.canTryingReset}
                                fill={true}
                                onClick={pageStore.tryReset}
                            >
                                パスワードを設定する
                            </Button>
                        </SubmitGroup>
                    </ProgressPanel>
                    <p
                        style={{whiteSpace: "nowrap", marginTop: "20px", color: "#6b7e8e"}}
                        data-testid="password-reset-message"
                    >
                        ※有効期限切れの場合は
                        <a
                            href="/admin/password-reset-request"
                            style={{textDecoration: "underline", color: "#6b7e8e"}}
                        >
                            パスワードリセット
                        </a>
                        から設定ください
                    </p>
                </div>
            </GuestLayout>
        );
    },
);
